import { render, staticRenderFns } from "./BaseQuickMenuSidebar.vue?vue&type=template&id=5a6e1172&scoped=true"
import script from "./BaseQuickMenuSidebar.vue?vue&type=script&lang=js"
export * from "./BaseQuickMenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./BaseQuickMenuSidebar.vue?vue&type=style&index=0&id=5a6e1172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e1172",
  null
  
)

export default component.exports